<a *ngIf="tag.timeRanges.length" role="button" (click)="onClick()" [ngClass]="[
		styles.wrapper,
		!isVerticalLayout && activeUserTagId === tag.userId ? 'theme-accent' : '',
		isVerticalLayout ? styles.verticalLayout : ''
	]">
	<vb-profile-picture [ngClass]="styles.profilePicture" [hilight]="isActiveTimeRage" [profileUrl]="tag.profileImageUri" [altTxt]="'UserProfile_ProfilePicture' | translate" [size]="'large'">
	</vb-profile-picture>
	<span class="radius-3" [ngClass]="[
			styles.name,
			isVerticalLayout && activeUserTagId === tag.userId ? 'theme-accent' : ''
		]">
		<span [ngClass]="styles.firstName">{{ tag.firstName }}</span>
		<span [ngClass]="styles.lastName">{{ tag.lastName }}</span>

		<span class="glyphicons chevron-right" [ngClass]="styles.chevronRight">
		</span>
	</span>
</a>

<div *ngIf="!tag.timeRanges.length" [ngClass]="[
		styles.wrapper,
		isVerticalLayout ? styles.verticalLayout : ''
	]">
	<vb-profile-picture [profileUrl]="tag.profileImageUri" [size]="'large'" [altTxt]="'UserProfile_ProfilePicture' | translate">
	</vb-profile-picture>
	<span [ngClass]="styles.name">
		<span [ngClass]="styles.firstName">{{ tag.firstName }}</span>
		<span [ngClass]="styles.lastName">{{ tag.lastName }}</span>
	</span>
</div>
